import React from 'react';
import { motion } from 'framer-motion';

const stats = [
  { value: '1500+', label: 'Projets réalisés', color: 'text-white' },
  { value: '700+', label: 'Clients satisfaits', color: 'text-white' },
  { value: '1275+', label: 'Évaluations positives', color: 'text-white' },
  { value: '250+', label: 'Smarts actifs', color: 'text-[#F97316]' },
  { value: '4.8★', label: 'Note moyenne', color: 'text-[#F97316]' },
];

const StatsSection = () => {
  return (
    <section className="py-16 bg-[#111111]">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-5 gap-8"
        >
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="text-center"
            >
              <div className={`text-3xl lg:text-4xl font-bold mb-2 ${stat.color}`}>
                {stat.value}
              </div>
              <div className="text-sm text-[#AAAAAA]">{stat.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default StatsSection;